import React from 'react';
import { Box, Stack, Skeleton, useTheme } from '@mui/material';
import { surfaceCard } from '../../../../Shared/surfaceCard';

const JobSkeleton = () => {
	const theme = useTheme();

	return (
		<Box sx={{ width: '100%', maxWidth: 1400, mx: 'auto' }}>
			<Skeleton variant="text" width={120} height={32} sx={{ mb: 3 }} />

			<Box sx={{ ...surfaceCard(theme), p: { xs: 2.5, md: 3.5 }, mb: 3 }}>
				<Skeleton variant="text" width="30%" height={20} />
				<Skeleton variant="text" width="60%" height={48} sx={{ mt: 1 }} />
				<Skeleton variant="text" width="25%" height={40} sx={{ mt: 2 }} />
			</Box>

			<Box
				sx={{
					display: 'grid',
					gridTemplateColumns: { xs: '1fr', lg: '1fr 320px' },
					gap: 3,
				}}
			>
				<Stack spacing={3}>
					<Box
						sx={{
							display: 'grid',
							gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
							gap: 3,
						}}
					>
						<Box sx={{ ...surfaceCard(theme), p: 2.5 }}>
							<Skeleton variant="text" width="40%" height={28} />
							<Skeleton
								variant="rectangular"
								height={120}
								sx={{ mt: 2, borderRadius: 2 }}
							/>
						</Box>
						<Box sx={{ ...surfaceCard(theme), p: 2.5 }}>
							<Skeleton variant="text" width="50%" height={28} />
							<Skeleton
								variant="rectangular"
								height={120}
								sx={{ mt: 2, borderRadius: 2 }}
							/>
						</Box>
					</Box>
					<Box sx={{ ...surfaceCard(theme), p: 2.5 }}>
						<Skeleton variant="text" width="30%" height={28} />
						<Skeleton
							variant="rectangular"
							height={280}
							sx={{ mt: 2, borderRadius: 2 }}
						/>
					</Box>
				</Stack>

				<Stack spacing={2.5}>
					<Box sx={{ ...surfaceCard(theme), p: 2.5 }}>
						<Skeleton variant="text" width="60%" height={20} sx={{ mb: 1 }} />
						<Skeleton
							variant="rectangular"
							height={40}
							sx={{ borderRadius: 2, mb: 2 }}
						/>
						<Skeleton variant="text" width="50%" height={20} sx={{ mb: 1 }} />
						<Skeleton
							variant="rectangular"
							height={40}
							sx={{ borderRadius: 2 }}
						/>
					</Box>
					<Box sx={{ ...surfaceCard(theme), p: 2.5 }}>
						<Skeleton
							variant="rectangular"
							height={36}
							sx={{ borderRadius: 2, mb: 1 }}
						/>
						<Skeleton
							variant="rectangular"
							height={36}
							sx={{ borderRadius: 2, mb: 1 }}
						/>
						<Skeleton
							variant="rectangular"
							height={36}
							sx={{ borderRadius: 2 }}
						/>
					</Box>
				</Stack>
			</Box>
		</Box>
	);
};

export default JobSkeleton;
